import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import OutsideClickHandler from 'react-outside-click-handler';
import cx from 'classnames';
import TableGrid from './TableGrid';
import Icon from '../../../../atoms/FontIcon';
import { PropertyControlledComponent } from '../../../index';
import s from '../../styleButton/styleButton.module.scss';
var TableControl = function TableControl(_ref) {
  var control = _ref.control,
    onToggle = _ref.onToggle,
    styleMenuClassName = _ref.styleMenuClassName,
    btnClassName = _ref.btnClassName;
  var icon = control.icon,
    iconSize = control.iconSize;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showTableControl = _useState2[0],
    setShowTableControl = _useState2[1];
  var outsideClickHandler = function outsideClickHandler() {
    return setShowTableControl(false);
  };
  var onMouseEnterHandler = function onMouseEnterHandler() {
    return setShowTableControl(true);
  };
  var onClickHandler = function onClickHandler(params) {
    setShowTableControl(false);
    onToggle(params);
  };
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: cx(s.btn, btnClassName),
    role: "button",
    onMouseEnter: onMouseEnterHandler,
    tabIndex: "-1"
  }, /*#__PURE__*/React.createElement(OutsideClickHandler, {
    onOutsideClick: outsideClickHandler
  }, /*#__PURE__*/React.createElement(PropertyControlledComponent, {
    controllerProperty: showTableControl
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(s.styleMenu, styleMenuClassName)
  }, /*#__PURE__*/React.createElement(TableGrid, {
    handleSubmit: onClickHandler
  })))), /*#__PURE__*/React.createElement(Icon, {
    size: iconSize
  }, icon)));
};
TableControl.propTypes = {
  control: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
  styleMenuClassName: PropTypes.string,
  btnClassName: PropTypes.string
};
TableControl.defaultProps = {
  styleMenuClassName: undefined,
  btnClassName: undefined
};
export default TableControl;